/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import { ICustomer } from '../../../../../store/ducks/customers/types';
import { loadReceiversForBP } from '../../../../../store/ducks/entry-order/actions';

interface IEmitterAndReceiver {
  emitterSelected: ICustomer;
  receiverSelected: ICustomer;
}

const useGetSenderAndReceiverDetails = (): IEmitterAndReceiver => {
  const dispatch = useDispatch();

  const customersData = useSelector(
    (state: ApplicationState) => state.customers
  );

  const { emitterId, receiverId } = useSelector(
    (state: ApplicationState) => state.longSteelShoppingCart
  );

  const receiverSelected = useSelector((state: ApplicationState) =>
    state.entryOrderReceivers?.receivers.find(
      (rcv) => rcv.customerId === receiverId
    )
  );

  const receiverState = useSelector(
    (state: ApplicationState) => state.entryOrderReceivers
  );

  const emitterSelected = customersData.customers.find(
    (customer) => customer.customerId === emitterId
  );

  const sameBP = emitterId === receiverId;

  const customerReceiverSelected = sameBP
    ? emitterSelected
    : customersData.customers.find(
        (customer) => customer.customerId === receiverId
      );

  const addressFieldsAreFilledIn = (customer: ICustomer | undefined) =>
    !!(
      customer?.name &&
      customer?.locality.address &&
      customer?.locality.city &&
      customer?.customerId &&
      customer?.locality.state &&
      customer?.taxNumber &&
      customer?.locality.zipCode
    );

  const addressEmitter = addressFieldsAreFilledIn(emitterSelected);
  const addressReceiver = sameBP
    ? addressEmitter
    : addressFieldsAreFilledIn(customerReceiverSelected);

  useEffect(() => {
    if (emitterId && receiverState?.customerId !== emitterId) {
      dispatch(loadReceiversForBP(emitterId));
    }
  }, [emitterId, receiverState?.customerId]);

  if (emitterSelected && addressEmitter && addressReceiver) {
    return {
      emitterSelected,
      receiverSelected: customerReceiverSelected!
    };
  }

  const emitterPurchaseSelected = sameBP
    ? receiverSelected
    : emitterSelected?.purchaseReceivers?.find(
        (purchaveReceiver) => purchaveReceiver.customerId === emitterId
      );

  return {
    emitterSelected:
      addressEmitter && emitterSelected
        ? emitterSelected
        : {
            ...emitterSelected!,
            locality: {
              address: emitterPurchaseSelected?.address ?? '',
              state: emitterPurchaseSelected?.state ?? '',
              city: emitterPurchaseSelected?.city ?? '',
              zipCode: emitterPurchaseSelected?.postalCode ?? '',
              country: '',
              district: '',
              zipcode: ''
            }
          },
    receiverSelected:
      addressReceiver && customerReceiverSelected
        ? customerReceiverSelected
        : ({
            taxNumber: receiverSelected?.taxNumber ?? '',
            name: receiverSelected?.name ?? '',
            customerId: receiverSelected?.customerId ?? '',
            locality: {
              address: receiverSelected?.address ?? '',
              state: receiverSelected?.state ?? '',
              city: receiverSelected?.city ?? '',
              zipCode: receiverSelected?.postalCode ?? '',
              country: '',
              district: '',
              zipcode: ''
            }
          } as ICustomer)
  };
};

export default useGetSenderAndReceiverDetails;
